import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

import AuthLogin from '../views/Auth/AuthLogin.vue';
// import Admin from '../views/Admin/Admin.vue';
// import Aviation from '../views/Aviation/Aviation.vue';
// import Flight from '../views/Aviation/Flight.vue';
// import Maritime from '../views/Maritime/Maritime.vue';
// import Voyage from '../views/Maritime/Voyage.vue';

import qs from 'qs';

Vue.use(VueRouter);

const DEFAULT_PAGE_TITLE = 'APIS Search';

const routes = [
  // Auth routes
  {
    path: '/login',
    name: 'Login',
    component: AuthLogin,
    beforeEnter: (to, from, next) => {
      // Prevent user from going to login page if already logged in
      if (store.getters.isLoggedIn) {
        return next({
          path: from.fullPath
        });
      }
      next();
    },
    props: true
  },

  // Admin routes
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('../views/Admin/Admin.vue'),
    meta: {
      title: 'Admin Dashboard',
      requiresAuth: true,
      adminAuth: true
    }
  },

  // Aviation routes
  {
    path: '/aviation',
    alias: '/',
    name: 'Aviation',
    component: () => import('../views/Aviation/Aviation.vue'),
    meta: {
      title: 'Flight List',
      requiresAuth: true
    }
  },
  {
    path: '/aviation/:id',
    name: 'Flight',
    component: () => import('../views/Aviation/Flight.vue'),
    children: [
      {
        path: 'travelers',
        name: 'FlightInfo',
        component: () => import('../views/Aviation/FlightInfo.vue'),
        meta: {
          title: 'Flight Summary',
          requiresAuth: true
        }
      },
      {
        path: 'travelers/:travelerId',
        name: 'FlightTraveler',
        component: () => import('../views/Aviation/FlightTraveler.vue'),
        meta: {
          title: 'Traveler Summary',
          requiresAuth: true
        }
      }
    ]
  },

  // Maritime routes
  {
    path: '/maritime',
    name: 'Maritime',
    component: () => import('../views/Maritime/Maritime.vue'),
    meta: {
      title: 'Voyage List',
      requiresAuth: true
    }
  },
  {
    path: '/maritime/:id',
    name: 'Voyage',
    component: () => import('../views/Maritime/Voyage.vue'),
    children: [
      {
        path: 'travelers',
        name: 'VoyageInfo',
        component: () => import('../views/Maritime/VoyageInfo.vue'),
        meta: {
          title: 'Voyage Summary',
          requiresAuth: true
        }
      },
      {
        path: 'travelers/:travelerId',
        name: 'VoyageTraveler',
        component: () => import('../views/Maritime/VoyageTraveler.vue'),
        meta: {
          title: 'Traveler Summary',
          requiresAuth: true
        }
      },

      // Errors
      { path: '/unauthorized', component: () => import('../views/Error/ErrorUnauthorized.vue'), meta: { title: 'Unauthorized' } },
      { path: '/*', component: () => import('../views/Error/Error404.vue'), meta: { title: 'Page Not Found' } }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  parseQuery(query) {
    return qs.parse(query);
  },
  stringifyQuery(query) {
    const result = qs.stringify(query, { encode: false });

    return result ? `?${result}` : '';
  }
});

// Add navigation guard
// Prevent unauthenticated user from accessing pages that require authentication
router.beforeEach((to, from, next) => {
  const metaAttributes = to.meta;
  if (metaAttributes.requiresAuth && !store.getters.isLoggedIn) {
    next({
      path: '/login',
      query: { redirect: to.fullPath },
      params: {
        passedErrors: ['You have been logged out.']
      }
    });
  } else if (metaAttributes.adminAuth && !store.getters.isAdmin) {
    next('/unauthorized');
  } else {
    next();
  }
});

// Set page title
router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = (to.meta.title || to.name) + ' - ' + DEFAULT_PAGE_TITLE || DEFAULT_PAGE_TITLE;
  });
});

export default router;
